export const BoxTitles = {
  Trigger: "Início",
  EventSource: "Público de eventos",
  // Públicos
  AudienceGroup: "Grupo de públicos",
  FullAudience: "Toda a base",
  SavedAudience: "Público salvo",
  ImportedAudience: "Público importado",
  BroadcastAudience: "Broadcast CB",
  // Filtros
  FilterGroup: "Grupo de filtros",
  AverageTicketFilter: "Ticket médio",
  OrderCountFilter: "Quantidade de pedidos",
  TotalSpendFilter: "Total gasto",
  LastConversionFilter: "Última conversão",
  BirthdayFilter: "Aniversariante",
  AgeFilter: "Idade",
  RegionFilter: "Região",
  RegisterTimeFilter: "Tempo de cadastro",
  ClimateProfileFilter: "Perfil climático",
  ConsumedProductsFilter: "Produtos consumidos",
  ConsumptionMomentsFilter: "Momentos de consumo",
  OriginFilter: "Origem de pedido",
  BrandsAndUnitsFilter: "Marcas e unidades",
  DaysWithoutConversionFilter: "Dias sem pedir",
  OrderFilter: "Pedidos",
  // Condicionais
  ConditionalGroup: "Grupo de condicionais",
  DayOfWeekConditional: "Dia da semana",
  DayOfMonthConditional: "Dia do mês",
  SpecificDayConditional: "Dia específico",
  SpecificClimateConditional: "Clima específico",
  AverageTicketConditional: "Ticket médio",
  OrderCountConditional: "Quantidade de pedidos",
  TotalSpendConditional: "Total gasto",
  AgeConditional: "Idade",
  LastConversionConditional: "Última conversão",
  BirthdayConditional: "Aniversariante",
  RegionConditional: "Região",
  RegisterTimeConditional: "Tempo de cadastro",
  ClimateProfileConditional: "Perfil climático",
  ConsumedProductsConditional: "Produtos consumidos",
  ConsumptionMomentsConditional: "Momentos de consumo",
  OriginConditional: "Origem de pedido",
  BrandsAndUnitsConditional: "Marcas e unidades",
  DaysWithoutConversionConditional: "Dias sem pedir",
  OrderConditional: "Pedidos",
  // Ações
  CreativeGroupAction: "Grupo de disparos",
  SmsCreativeAction: "Disparo de SMS",
  PushCreativeAction: "Disparo de PUSH",
  EmailCreativeAction: "Disparo de Email",
  WhatsAppCreativeAction: "Disparo de WhatsApp",
  // Saídas
  ExportAudienceOutput: "Exportar público",

  RFVProfileFilter: "Perfis RFV",
  OrderFrequencyConditional: "Frequencia de pedidos",
  RFVProfileConditional: "Perfil RFV",
  OrderFrequencyFilter: "Frequencia de pedidos",
  CustomerPhoneFilter: "Telefone do cliente",
};
